import React from "react";
// import '../../css/Loader.module.css';

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
    )
};

export default Loader;
